import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import ReactHtmlParser from "react-html-parser";
import axios from "axios";
import { Link } from "gatsby";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";

import { setFilter } from "../../app/actions";
import {
  queryObjectProducts,
  queryObjectCourses,
  queryObjectCourseDates,
} from "./queries";
import ProductCardItem from "../Product/ProductCardItem";
// import Logo from "./Logo";
import styles from "./styles";

const useStyles = makeStyles((theme) => styles(theme));

const mapStateToProps = (state) => ({
  filters: state.ShopSettings.filters,
  query: state.query,
});

const mapDispatchToProps = (dispatch) => ({
  setFilter: (prevFilters, filter) => dispatch(setFilter(prevFilters, filter)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

function SearchPage({ state }) {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState({});
  const [searchingProducts, setSearchingProducts] = useState(true);
  const [searchingCourses, setSearchingCourses] = useState(true);
  const [courses, setCourses] = useState([]);
  const [courseDates, setCourseDates] = useState([]);

  const classes = useStyles();

  useEffect(() => {
    if (state && state.query) {
      setProducts([]);
      setCourses([]);
      setCourseDates([]);
      if (state.category !== "training") {
        fetchProducts("");
      } else {
        setSearchingProducts(false);
      }
      if (state.category === "all") {
        fetchCourses("", [], state.query);
        fetchCourseDates("");
      }
    }
  }, [state]); //eslint-disable-line

  useEffect(() => {
    buildCategories();
  }, [products]); //eslint-disable-line

  function buildCategories() {
    const categories = {};
    products
      .filter((product) => {
        if (!state || state.category === "all") return product;
        const categories = product.productCategories.edges.map(
          (edge) => edge.node.slug
        );
        return categories.includes(state.category);
      })
      .map((product) => {
        product.productCategories.edges.map((category) => {
          if (!category.node.parent) {
            const { name, slug } = category.node;
            categories[slug] = { name, slug, subcategories: {} };
          }
          return null;
        });
        return product;
      })
      .map((product) => {
        product.productCategories.edges.map((category) => {
          if (category.node.parent) {
            const { name, slug, parent, productCategoryExtras } = category.node;
            if (!categories[parent.node.slug]) return null;
            const oldProducts = categories[parent.node.slug].subcategories[slug]
              ? categories[parent.node.slug].subcategories[slug].products
              : [];
            categories[parent.node.slug].subcategories[slug] = {
              name,
              slug,
              productCategoryExtras,
              products: [...oldProducts, { ...product }],
            };
          }
          return null;
        });

        return product;
      })
      .sort((a, b) => {
        if (a.title.toLowerCase().includes(state.query.toLowerCase())) return -1;
        return 1;
      });

    setCategories(categories);
  }

  function fetchProducts(next = "", prevData = []) {
    if (!state || !state.query) return;

    setSearchingProducts(true);
    axios
      .post(
        `${process.env.GATSBY_ADMIN_URL}graphql`,
        queryObjectProducts(state.query, next),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        return {
          products: res.data.data.products.edges.map((node) => node.node),
          next: res.data.data.products.pageInfo.endCursor,
          hasNextPage: res.data.data.products.pageInfo.hasNextPage,
        };
      })
      .then((data) => {
        if (data.hasNextPage) {
          fetchProducts(data.next, prevData.concat(data.products));
        } else {
          setProducts(prevData.concat(data.products));
          setSearchingProducts(false);
        }
      });
  }

  function fetchCourses(next = "", prevData = [], query) {
    setSearchingCourses(true);
    axios
      .post(
        `${process.env.GATSBY_ADMIN_URL}graphql`,
        queryObjectCourses(query, next),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        return {
          courses: res.data.data.courses.edges.map((node) => node.node),
          next: res.data.data.courses.pageInfo.endCursor,
          hasNextPage: res.data.data.courses.pageInfo.hasNextPage,
        };
      })
      .then((data) => {
        return {
          courses: data.courses.filter((course) => {
            if (course.title.toLowerCase().includes(query.toLowerCase()))
              return course;
            if (
              course.courses.provider.name
                .toLowerCase()
                .includes(query.toLowerCase())
            )
              return course;
            if (course.courses.code.toLowerCase().includes(query.toLowerCase()))
              return course;
            return false;
          }),
          next: data.next,
          hasNextPage: data.hasNextPage,
        };
      })
      .then((data) => {
        return {
          courses: data.courses.sort((a, b) => a.title.localeCompare(b.title)),
          next: data.next,
          hasNextPage: data.hasNextPage,
        };
      })
      .then((data) => {
        if (data.hasNextPage) {
          fetchCourses(data.next, prevData.concat(data.courses), query);
        } else {
          setCourses(prevData.concat(data.courses));
          setSearchingCourses(false);
        }
      });
  }

  function fetchCourseDates(next = "", prevData = []) {
    axios
      .post(
        `${process.env.GATSBY_ADMIN_URL}graphql`,
        queryObjectCourseDates(next),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        return {
          courseDates: res.data.data.courseDates.edges
            .map((node) => node.node)
            .filter((node) => node.courseData.course)
            .map((node) => node.courseData.course.databaseId),
          next: res.data.data.courseDates.pageInfo.endCursor,
          hasNextPage: res.data.data.courseDates.pageInfo.hasNextPage,
        };
      })
      .then((data) => {
        if (data.hasNextPage) {
          fetchCourseDates(data.next, prevData.concat(data.courseDates));
        } else {
          setCourseDates(prevData.concat(data.courseDates));
        }
      });
  }

  function renderError() {
    return (
      <div className="no-results">
        <p>Your search hasn’t matched any of our available products.</p>
        <p>Looking for information on something specific?</p>
        <p>
          Get in touch with the experts at Workshop Pro today via the{" "}
          <Link to="/contact-us/">contact page</Link>.{" "}
        </p>
      </div>
    );
  }

  function Logo(props) {
    if (!props.provider.courseProviderInfo.logo) return null;

    return (
      <img
        src={props.provider.courseProviderInfo.logo.sourceUrl}
        className="brand-logo"
        alt={``}
      />
    );
  }

  return (
    <div className={classes.searchPage}>
      {Object.keys(categories).length > 0 && <p>Search Results:</p>}
      {state && state.query && (searchingProducts || searchingCourses) && (
        <p className={classes.searching}>Searching...</p>
      )}

      {Object.keys(categories).length > 0 && (
        <section>
          {Object.keys(categories).map((category, index) => {
            if (state.category !== "all" && category !== state.category)
              return null;

            const data = categories[category];
            return (
              <Grid container spacing={0} key={index} justify="flex-end">
                <Grid item xs={12} md={12}>
                  <h3 className="prod-category">{data.name}</h3>
                </Grid>
                {Object.keys(data.subcategories).map((subcategory, _index) => {
                  const subData = data.subcategories[subcategory];
                  return (
                    <Grid item xs={12} md={12} key={_index}>
                      <Grid container spacing={3} justify="flex-end">
                        <Grid item xs={12} md={4} lg={3}>
                          <div className="sub-category">
                            <img
                              src={
                                subData.productCategoryExtras.categoryIcon
                                  ?.sourceUrl
                              }
                              alt={subData.name}
                              name={subData.name}
                            />
                            <h4>{subData.name}</h4>
                            <Link
                              to={
                                "/category/" +
                                data.slug +
                                "/" +
                                subData.slug +
                                "/"
                              }
                            >
                              View All
                            </Link>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={8} lg={9}>
                          <Grid
                            container
                            spacing={3}
                            justify="flex-start"
                            style={{ marginBottom: 0 }}
                          >
                            {subData.products
                              .filter(
                                (v, i, a) =>
                                  a.findIndex((t) => t.id === v.id) === i
                              )
                              .map((product, __index) => {
                                const image = product.product.productGallery;
                                return (
                                  <Grid
                                    key={__index}
                                    item
                                    xs={12}
                                    ms={6}
                                    lg={4}
                                  >
                                    <ProductCardItem
                                      uri={product.uri}
                                      productGallery={image}
                                      title={product.title}
                                      code={product.product.code}
                                    />
                                  </Grid>
                                );
                              })}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
            );
          })}
        </section>
      )}

      {!searchingProducts && !searchingCourses && courses.length > 0 && (
        <div className={classes.courseResults}>
          <h3 className="prod-category">Training</h3>

          <div className="course-titles">
            <div className="provider">Provider</div>
            <div className="title">Course Title</div>
            <div className="type">Course Type</div>
            <div className="category">Course Category</div>
            <div className="length">Length</div>
            <div className="dates">Date</div>
          </div>
          <div className="course-listing">
            {courses
              .sort((a, b) => {
                if (a.title.toLowerCase().includes(state.query.toLowerCase()))
                  return -1;
                return 1;
              })
              .filter(
                (v, i, a) =>
                  a.findIndex((t) => t.databaseId === v.databaseId) === i
              )
              .map((course) => {
                let hasOnline = false;
                let places = '';
                if (course.courses.places) {
                  hasOnline = course.courses.places.filter(place => place === 'Online').length > 0;
                  if (course.courses.places.length > 4) {
                    places = <span>Multiple Course Locations Available</span>
                  } else {
                    places = course.courses.places.map(place => <span key={course.id + place}>{place}</span>)
                  }
                }
                return (
                  <div key={course.id} className="course-item">
                    <div className="provider">
                      <span className="title">Provider </span>
                      <Logo provider={course.courses.provider} />
                    </div>
                    <div className="title">
                      <span className="title">Course Title</span>
                      <Link to={course.uri}>
                        {ReactHtmlParser(course.title)}
                      </Link>
                    </div>
                    <div className="places">
                      <span className="title">Location</span>
                      {places}
                    </div>
                    <div className="category">
                      <span className="title">Course Category</span>
                      {course.courseCategories !== null && course.courseCategories.nodes.length > 0 && (<span>{course.courseCategories.nodes[0].name}</span>)}
                    </div>
                    <div className="length">
                      <span className="title">Length</span>
                      {course.courses.length !== null && (
                        <span>{course.courses.length}</span>
                      )}
                    </div>
                    <div className="dates">
                      <span className="title">Date</span>
                      {hasOnline && <span>Accessible 24/7</span>}
                      {!hasOnline && courseDates.includes(course.databaseId) && (<span>Multiple dates available</span>)}
                      {!hasOnline && !courseDates.includes(course.databaseId) && (<span>Contact for Availability</span>)}
                    </div>
                    <div className="link">
                      <Link to={course.uri}>Course Detail</Link>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      )}

      {state && state.query &&
        !searchingProducts &&
        !searchingCourses &&
        products.length === 0 &&
        courses.length === 0 &&
        renderError()}
    </div>
  );
}

export default connector(SearchPage);
